import React from 'react';
import { 
  Box, 
  Toolbar, 
  Typography, 
  Card, 
  CardContent, 
  Grid, 
  Paper, 
  List, 
  ListItem, 
  ListItemText, 
  ListItemIcon,
  Chip,
  Button,
  Alert,
  Divider
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Assessment as AssessmentIcon,
  Settings as SettingsIcon,
  Security as SecurityIcon,
  Notifications as NotificationsIcon,
  ContentPaste as ContentPasteIcon,
  Payment as PaymentIcon,
  Analytics as AnalyticsIcon,
  Report as ReportIcon,
  Backup as BackupIcon,
  TrendingUp as TrendingUpIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import UserManagement from '../../Dashboard/Components/UserManagement';
import RedemptionManagement from './RedemptionManagement';
import CategoryManagement from './CategoryManagement';
import EntityManagement from './EntityManagement';
import EntityActions from './EntityActions';
import AffiliateDetails from './AffiliateDetails';
import UserAccess from './UserAccess';
import AuditLog from './Auditlog';
import ShopifyOrders from "./shopifyOrders"; // adjust path as needed
import EntityReferralStatistics from './EntityReferralStatistics';

const drawerWidth = 240;

const AdminDashboardContent = ({ selectedMenu, sidebarOpen, isMobile, isTablet, isDesktop }) => {
  const drawerWidth = 280;
  const collapsedWidth = 80;

  return (
         <Box
       component="main"
       sx={{
         flexGrow: 1,
         width: {
           xs: '100%',
           sm: `calc(100% - ${sidebarOpen ? drawerWidth : collapsedWidth}px)`,
           md: `calc(100% - ${sidebarOpen ? drawerWidth : collapsedWidth}px)`,
           lg: `calc(100% - ${sidebarOpen ? drawerWidth : collapsedWidth}px)`
         },
         transition: 'width 0.3s',
            minHeight: '100vh',
         display: 'flex',
        height: '100vh',
           overflowX: 'hidden',      //
          overflowY: 'auto',  

         flexDirection: 'column',
         backgroundColor: '#f5f5f5'
       }}
       className='mainComponentDashboard'
     >
                <Toolbar sx={{ minHeight: { xs: '48px', sm: '64px' } }} />

      {/* Content Rendering */}
                    {selectedMenu === 'Dashboard Overview' && (
         <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
                        <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#214F7D' }}>
               Dashboard Overview
             </Typography>
             
             <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            {/* Stats Cards - Responsive Grid */}
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ p: { xs: 2, sm: 3 }, textAlign: 'center', bgcolor: '#e3f2fd', height: '100%' }}>
                <PeopleIcon sx={{ fontSize: { xs: 32, sm: 40, md: 48 }, color: '#1976d2', mb: 2 }} />
                <Typography variant="h5" color="primary">1,247</Typography>
                <Typography variant="body2" color="text.secondary">Total Users</Typography>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ p: { xs: 2, sm: 3 }, textAlign: 'center', bgcolor: '#f3e5f5', height: '100%' }}>
                <PaymentIcon sx={{ fontSize: { xs: 32, sm: 40, md: 48 }, color: '#7b1fa2', mb: 2 }} />
                <Typography variant="h5" color="secondary">892</Typography>
                <Typography variant="body2" color="text.secondary">Active Payments</Typography>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ p: { xs: 2, sm: 3 }, textAlign: 'center', bgcolor: '#e8f5e8', height: '100%' }}>
                <TrendingUpIcon sx={{ fontSize: { xs: 32, sm: 40, md: 48 }, color: '#388e3c', mb: 2 }} />
                <Typography variant="h5" sx={{ color: '#388e3c' }}>+15%</Typography>
                <Typography variant="body2" color="text.secondary">Growth Rate</Typography>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ p: { xs: 2, sm: 3 }, textAlign: 'center', bgcolor: '#fff3e0', height: '100%' }}>
                <WarningIcon sx={{ fontSize: { xs: 32, sm: 40, md: 48 }, color: '#f57c00', mb: 2 }} />
                <Typography variant="h5" sx={{ color: '#f57c00' }}>23</Typography>
                <Typography variant="body2" color="text.secondary">Pending Issues</Typography>
              </Card>
            </Grid>
            
            {/* Recent Activity - Full width on mobile, 2/3 on larger screens */}
            <Grid item xs={12} md={8}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Recent Activity</Typography>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                    <ListItemText 
                      primary="New user registration: John Doe" 
                      secondary="2 minutes ago"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon><PaymentIcon color="primary" /></ListItemIcon>
                    <ListItemText 
                      primary="Payment completed: $25.00" 
                      secondary="5 minutes ago"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon><InfoIcon color="info" /></ListItemIcon>
                    <ListItemText 
                      primary="System backup completed" 
                      secondary="1 hour ago"
                    />
                  </ListItem>
                </List>
              </Card>
            </Grid>
            
            {/* Quick Actions - Full width on mobile, 1/3 on larger screens */}
            <Grid item xs={12} md={4}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Quick Actions</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Button variant="outlined" startIcon={<PeopleIcon />} fullWidth>
                    View All Users
                  </Button>
                  <Button variant="outlined" startIcon={<PaymentIcon />} fullWidth>
                    Payment Reports
                  </Button>
                  <Button variant="outlined" startIcon={<SettingsIcon />} fullWidth>
                    System Settings
                  </Button>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {selectedMenu === 'User Management' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <UserManagement />
            </Box>
          </CardContent>
        </Card>
      )}

        {selectedMenu === 'Category Management' && (
          <Card sx={{ p: 2 }} className='dashboardCard'>
            <CardContent className='pb-16px'>
  <Box sx={{ 
    p: 2, 
    height: 'calc(100vh - 64px)', 
    display: 'flex', 
    flexDirection: 'column',
    overflow: 'hidden'   // ← stops rows bleeding out
  }}>
                <CategoryManagement />
              </Box>
            </CardContent>
          </Card>
        )}

        {selectedMenu === 'Entity Management' && (
          <Card sx={{ p: 2 }} className='dashboardCard'>
            <CardContent className='pb-16px'>
              <Box sx={{ mx: 'auto' }}>
                <EntityManagement />
              </Box>
            </CardContent>
          </Card>
        )}

        {selectedMenu === 'Gifts' && (
          <Card sx={{ p: 2 }} className='dashboardCard'>
            <CardContent className='pb-16px'>
              <Box sx={{ mx: 'auto' }}>
                <AffiliateDetails />
              </Box>
            </CardContent>
          </Card>
        )}

        {selectedMenu === 'User Access' && (
          <Card sx={{ p: 2 }} className='dashboardCard'>
            <CardContent className='pb-16px'>
              <Box sx={{ mx: 'auto' }}>
                <UserAccess />
              </Box>
            </CardContent>
          </Card>
        )}
        {selectedMenu === 'Audit Log' && (
  <Card sx={{ p: { xs: 2, sm: 3 } }} className='dashboardCard'>
    <CardContent className='pb-16px'>
      <Box sx={{ mx: 'auto' }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{ mb: 3 }}
          className='green-title'
        >
          {selectedMenu}
        </Typography>
        <AuditLog />
      </Box>
    </CardContent>
  </Card>
)}  
{selectedMenu === 'Shopify Orders' && (
  <Card sx={{ p: { xs: 2, sm: 3 } }} className='dashboardCard'>
    <CardContent className='pb-16px'>
      <Box sx={{ mx: 'auto' }}>
        <ShopifyOrders />
      </Box>
    </CardContent>
  </Card>
)}  
        {/* Entity Action Menus */}
       {(selectedMenu === 'View Referrals' || 
          selectedMenu === 'Copy Referral Link' || 
          selectedMenu === 'View Visiting Card' || 
          selectedMenu === 'View Certificate' || 
          selectedMenu === 'View Entity Details' || 
          selectedMenu === 'Edit Entity') && (
          <Card sx={{ p: { xs: 2, sm: 3 }, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }} className='dashboardCard'>
            <CardContent sx={{ flex: 1, overflowY: 'auto', pb: '16px !important' }} className='entityCardcontent'>
              <Box sx={{ mx: 'auto' }} className="entityReferrals">
                <EntityActions selectedAction={selectedMenu} />
              </Box>
            </CardContent>
          </Card>
        )}
             {selectedMenu === 'Content Management' && (
         <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
                        <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#214F7D' }}>
               Content Management
             </Typography>
             
             <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid item xs={12} md={6}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Manage Pages</Typography>
                <List>
                  <ListItem>
                    <ListItemText primary="Home Page" secondary="Last updated: 2 days ago" />
                    <Button size="small" variant="outlined">Edit</Button>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="About Us" secondary="Last updated: 1 week ago" />
                    <Button size="small" variant="outlined">Edit</Button>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Contact Page" secondary="Last updated: 3 days ago" />
                    <Button size="small" variant="outlined">Edit</Button>
                  </ListItem>
                </List>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Media Library</Typography>
                <Alert severity="info" sx={{ mb: 2 }}>
                  Manage images, documents, and other media files
                </Alert>
                <Button variant="contained" startIcon={<ContentPasteIcon />}>
                  Upload New Content
                </Button>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

             {selectedMenu === 'Payment Management' && (
         <Box sx={{ p: { xs: 2, sm: 3 } }}>
           <RedemptionManagement />
         </Box>
       )}

      {selectedMenu === 'Analytics & Reports' && (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#214F7D' }}>
            Analytics & Reports
          </Typography>
          
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid item xs={12} md={6}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>User Analytics</Typography>
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <AnalyticsIcon sx={{ fontSize: { xs: 40, sm: 60, md: 72 }, color: '#1976d2', mb: 2 }} />
                  <Typography variant="body1" color="text.secondary">
                    User growth charts and statistics will be displayed here
                  </Typography>
                </Box>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Revenue Analytics</Typography>
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <TrendingUpIcon sx={{ fontSize: { xs: 40, sm: 60, md: 72 }, color: '#388e3c', mb: 2 }} />
                  <Typography variant="body1" color="text.secondary">
                    Revenue trends and financial reports will be displayed here
                  </Typography>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {selectedMenu === 'System Reports' && (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#214F7D' }}>
            System Reports
          </Typography>
          
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>System Health</Typography>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                    <ListItemText primary="Database" secondary="Healthy" />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                    <ListItemText primary="API Services" secondary="Operational" />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                    <ListItemText primary="File Storage" secondary="Normal" />
                  </ListItem>
                </List>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={8}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Error Logs</Typography>
                <Alert severity="info">
                  System error logs and performance metrics will be displayed here
                </Alert>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {selectedMenu === 'Notifications' && (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#214F7D' }}>
            Notifications
          </Typography>
          
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid item xs={12} md={8}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>System Notifications</Typography>
                <List>
                  <ListItem>
                    <ListItemIcon><InfoIcon color="info" /></ListItemIcon>
                    <ListItemText 
                      primary="System maintenance scheduled" 
                      secondary="Tomorrow at 2:00 AM"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon><WarningIcon color="warning" /></ListItemIcon>
                    <ListItemText 
                      primary="High server load detected" 
                      secondary="1 hour ago"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                    <ListItemText 
                      primary="Backup completed successfully" 
                      secondary="2 hours ago"
                    />
                  </ListItem>
                </List>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Notification Settings</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Button variant="outlined" fullWidth>
                    Email Notifications
                  </Button>
                  <Button variant="outlined" fullWidth>
                    SMS Notifications
                  </Button>
                  <Button variant="outlined" fullWidth>
                    Push Notifications
                  </Button>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {selectedMenu === 'Security Settings' && (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#214F7D' }}>
            Security Settings
          </Typography>
          
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid item xs={12} md={6}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Access Control</Typography>
                <List>
                  <ListItem>
                    <ListItemText primary="Two-Factor Authentication" secondary="Enabled" />
                    <Chip label="Active" color="success" size="small" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Session Timeout" secondary="30 minutes" />
                    <Button size="small" variant="outlined">Configure</Button>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="IP Whitelist" secondary="Configured" />
                    <Button size="small" variant="outlined">Manage</Button>
                  </ListItem>
                </List>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Security Logs</Typography>
                <Alert severity="info">
                  Recent security events and access logs will be displayed here
                </Alert>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {selectedMenu === 'System Settings' && (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#214F7D' }}>
            System Settings
          </Typography>
          
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid item xs={12} md={6}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>General Settings</Typography>
                <List>
                  <ListItem>
                    <ListItemText primary="Site Name" secondary="PeaceKeeper Movement" />
                    <Button size="small" variant="outlined">Edit</Button>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Default Language" secondary="English" />
                    <Button size="small" variant="outlined">Change</Button>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Timezone" secondary="UTC+0" />
                    <Button size="small" variant="outlined">Configure</Button>
                  </ListItem>
                </List>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Email Configuration</Typography>
                <Alert severity="info">
                  SMTP settings and email templates configuration
                </Alert>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {selectedMenu === 'Backup & Restore' && (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#214F7D' }}>
            Backup & Restore
          </Typography>
          
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid item xs={12} md={8}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Backup History</Typography>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                    <ListItemText 
                      primary="Full System Backup" 
                      secondary="Last backup: 2 hours ago - Size: 2.5 GB"
                    />
                    <Button size="small" variant="outlined">Download</Button>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                    <ListItemText 
                      primary="Database Backup" 
                      secondary="Last backup: 1 day ago - Size: 500 MB"
                    />
                    <Button size="small" variant="outlined">Download</Button>
                  </ListItem>
                </List>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Card sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" gutterBottom>Actions</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Button variant="contained" startIcon={<BackupIcon />}>
                    Create Backup
                  </Button>
                  <Button variant="outlined" startIcon={<BackupIcon />}>
                    Restore from Backup
                  </Button>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {/* Default content when no menu is selected */}
      {!selectedMenu && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto', textAlign: 'center' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                Welcome to Admin Panel
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Select a menu item from the sidebar to get started.
              </Typography>
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default AdminDashboardContent;
